
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {
  fetchInsightTraffic,
  changeSort
} from 'redux/modules/insights/actions'
import {setTimePeriod} from 'redux/modules/currentUser/actions'
import {getTrafficData} from 'redux/modules/insights/selectors'
import {
  getCurrentTimePeriod,
  getTimePeriodRanges,
  getAggregatedSites
} from 'redux/modules/currentUser/selectors'
import isRangeEqual from 'utils/isRangeEqual'
import OverviewTable from 'components/OverviewTable'
import ColorLegend from 'components/ColorLegend'
import formatTimePeriodDate from 'utils/formatTimePeriodDate'
import isEqual from 'lodash/isEqual'
import {getSelectedDateRange} from 'redux/modules/currentUser/selectors'

export class TrafficInsightView extends React.Component {
  static propTypes = {
    today: PropTypes.instanceOf(Date),
    trafficData: PropTypes.array,
    fetchInsightTraffic: PropTypes.func,
    setTimePeriod: PropTypes.func,
    changeSort: PropTypes.func,
    timePeriod: PropTypes.string,
    dynamicDateType: PropTypes.string,
    timePeriodRanges: PropTypes.object,
    sortKey: PropTypes.string,
    sortDirection: PropTypes.string,
    sites: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    isTrafficDataFetching: PropTypes.bool,
    crossSiteMode: PropTypes.bool
  }

  static contextTypes = {
    currency: PropTypes.string,
    timezone: PropTypes.string
  }

  componentDidMount() {
    const {fetchInsightTraffic, crossSiteMode} = this.props
    const {currency, timezone} = this.context
    fetchInsightTraffic(['session:count'], crossSiteMode, currency, timezone)
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {currency, timezone} = nextContext
    const {fetchInsightTraffic, sites, timePeriod, timePeriodRanges} = this.props
    const {timePeriodRanges: nextTimePeriodRanges, currentMonthDataFetching, crossSiteMode} = nextProps
    const sitesChanged = !isEqual(sites, nextProps.sites)

    if (!nextTimePeriodRanges || !timePeriodRanges) return null

    const timePeriodChanged = timePeriod !== nextProps.timePeriod
    const timeRangesValid = !!nextTimePeriodRanges.start && !!nextTimePeriodRanges.end
    if (!timeRangesValid) return null

    const timeRangesChanged = !(
      isRangeEqual(timePeriodRanges.start, nextTimePeriodRanges.start) &&
      isRangeEqual(timePeriodRanges.end, nextTimePeriodRanges.end)
    )
    if (
      !currentMonthDataFetching &&
      (sitesChanged || timePeriodChanged || timeRangesChanged)
    ) {
      fetchInsightTraffic(['session:count'], crossSiteMode, currency, timezone)
    }
  }

  render() {
    const {
      timePeriod,
      dynamicDateType,
      timePeriodRanges,
      trafficData,
      sortKey,
      today,
      sortDirection,
      isTrafficDataFetching,
      setTimePeriod,
      changeSort
    } = this.props

    if (!timePeriodRanges) return null

    const currentPeriodName = formatTimePeriodDate(timePeriod, timePeriodRanges.start.start)
    const anotherPeriodName = formatTimePeriodDate(timePeriod, timePeriodRanges.end.start)
    const columns = [
      {
        type: 'chart',
        label: (
          <div className='table-cell is-grow'>
            Traffic Trend
            <ColorLegend
              title={`These graphs show comparison between ${currentPeriodName} and ${anotherPeriodName}.`}
              visible
            />
          </div>
        ),
        width: 'grow',
        dataKey: 'traffic',
        accumulatedValues: true
      },
      {
        type: 'value',
        headerKey: 'trafficSum',
        label: 'Visits',
        description: currentPeriodName,
        width: '100px',
        dataKey: 'trafficSum',
        format: 'number',
        applyColor: false
      },
      {
        type: 'value',
        headerKey: 'trafficAbsoluteSumChange',
        label: 'Change',
        description: `comp ${anotherPeriodName}`,
        width: '100px',
        dataKey: 'trafficAbsoluteSumChange',
        format: 'signed-number',
        applyColor: true
      },
      {
        type: 'value',
        headerKey: 'trafficRelativeSumChange',
        label: '% change',
        description: `comp ${anotherPeriodName}`,
        width: '100px',
        dataKey: 'trafficRelativeSumChange',
        format: 'signed-percent',
        applyColor: true
      }
    ]

    return (
      <div className='traffic-unpaid-insight-view'>
        <OverviewTable
          timePeriod={timePeriod}
          timePeriodRanges={timePeriodRanges}
          data={trafficData}
          isLoading={isTrafficDataFetching}
          disabled={isTrafficDataFetching}
          sortKey={sortKey}
          sortDirection={sortDirection}
          today={today}
          setTimePeriod={setTimePeriod}
          dynamicDateType={dynamicDateType}
          changeSort={changeSort}
          columns={columns}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const {
    isFetching,
    sortDirection,
    sortKey
  } = state.insights.traffic
  const timePeriod = getCurrentTimePeriod(state)
  const timePeriodRanges = getTimePeriodRanges(state)
  const crossSiteMode = props.route.crossSiteMode
  const {dynamicDateType} = getSelectedDateRange(state)

  return {
    today: state.today,
    crossSiteMode,
    timePeriod,
    timePeriodRanges,
    dynamicDateType,
    sites: getAggregatedSites(state, crossSiteMode),
    trafficData: getTrafficData(state, timePeriodRanges),
    isTrafficDataFetching: isFetching,
    sortDirection,
    sortKey
  }
}

const mapDispatchToProps = {
  fetchInsightTraffic,
  setTimePeriod,
  changeSort
}

export default connect(mapStateToProps, mapDispatchToProps)(TrafficInsightView)



// WEBPACK FOOTER //
// ./client/views/TrafficInsightView/index.js